<template>
<div>
  <b-modal ref="modal" title=" Novo crédito" header-class="border-bottom-0" size="lg" no-close-on-backdrop>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <search-input :alias="form.person_id.alias" v-model="form.person_id.value" :displayedValue="form.name.value" :form="form" :name="'person_id'" @search="searchPerson($event)" :searchResult="searchPersonResults.results" :isLoading="searchPersonResults.isLoading" @selected="setPerson($event)">
            <search-input-option v-for="(row, index) in searchPersonResults.results.data" :key="index" :index="index" @click="setPerson(row)">
              <div>
                {{ row.name }}
                <br />
                <small class="text-muted">{{ row.cpf }}</small>
                <br />
              </div>
            </search-input-option>
          </search-input>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <text-input :form="form" :name="'document'" v-model="form.document.value" :alias="form.document.alias" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Historico:</label>
            <textarea v-model="form.history.value" maxlength="500" class="form-control" id="exampleFormControlTextarea1" rows="5"></textarea>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-12">
          <number-input :form="form" :name="'value'" v-model="form.value.value" :alias="form.value.alias" />
        </div>
      </div>
    </div>
    <br />

    <b-alert :show="alertData.isVisible" fade variant="danger" @dismissed="alertData.isVisible = false" dismissible>{{ alertData.message }}</b-alert>

    <div slot="modal-footer">
      <button role="button" class="btn btn-outline-secondary" @click="$refs.modal.hide()">
        <i class="fas fa-times"></i> Cancelar
      </button>
      <button role="button" class="btn btn-success" style="margin-left:5px" @click="store">
        <i class="fas fa-check"></i> Salvar
      </button>
    </div>
  </b-modal>
</div>
</template>

<script>
import Form from "../../../mixins/Form";


export default {
  components: {},

  data: function () {
    return {
      form: new Form({
        person_id: {
          alias: "Cliente",
          validate: {
            required: true
          }
        },

        name: {},

        document: {
          alias: "Documento",
          validate: {
            required: true
          }
        },
        value: {
          alias: "Valor",
          validate: {
            required: true
          }
        },

        history: {},

      }),


      selectedPerson: null,

      searchPersonResults: {
        results: {},
        isLoading: false
      },

      error: null,

      alertData: {
        isVisible: false,
        message: null
      }
    };
  },

  mounted() {},

  methods: {
    open(id) {
      this.resetForm();
      this.$refs.modal.show();

    },

    searchPerson(search) {
      this.searchPersonResults.isLoading = true;

      axios
        .post(process.env.BASE_URL + "api/searchpersonbillreceiveble/select?page=" + search.page, {
          name: search.text,
          type: 'c',
          status: 1
        })
        .then(response => {
          this.searchPersonResults.results = response.data;

          this.searchPersonResults.isLoading = false;
        })
        .catch(error => {

          this.error = error;
        });
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.person_id.value = person.id;

      this.form.name.value = person.name;
    },

    getAttributes() {
      return {
        ...this.form.getValues(),

      };
    },

    store() {
      if (this.form.isValid()) {
        this.$store.commit("showLoading");
        axios
          .post('api/bill-receiveble-credit/store', this.getAttributes())

          .then(response => {
            this.$refs.modal.hide();

            this.$store.commit("hideLoading");

            this.$emit("store");

            this.$store.commit("showAlert", {
              message: "Lançamento efetuado!",
              type: "success"
            });

            return;
          })
          .catch(error => {
            this.error = error;

            this.$store.commit("hideLoading");

            return;
          });
      } else {

        this.form.isValid();

        this.alertData.message = this.form.getFirstErrorMsg();

        this.alertData.isVisible = true;
      }
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();

    }
  }
};
</script>
